"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 23 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var CompetitorProductFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorProductFilterConverter, _DataObjectConverter_);

  function CompetitorProductFilterConverter() {
    _classCallCheck(this, CompetitorProductFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductFilterConverter).apply(this, arguments));
  }

  return CompetitorProductFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorProductFilterConverter = CompetitorProductFilterConverter;